import { render, staticRenderFns } from "./TarnsactionLog.vue?vue&type=template&id=705d989e"
import script from "./TarnsactionLog.vue?vue&type=script&lang=js"
export * from "./TarnsactionLog.vue?vue&type=script&lang=js"
import style0 from "./TarnsactionLog.vue?vue&type=style&index=0&id=705d989e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports